/**
 * Dialog action handler.
 * Delegates to the configured dialog driver (sweetalert2, smart-dialog, or native).
 */
let dialog = function (actionData) {
    // Try SweetAlert2 first (most common)
    if (typeof window.Swal !== 'undefined') {
        const swalOptions = {
            icon: actionData.type,
            title: actionData.title,
            html: actionData.html,
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
            ...actionData.options,
        };

        Swal.fire(swalOptions);
        return;
    }

    // Fallback: native browser dialog
    console.warn('[Smart] No dialog library loaded. Using native alert.');
    alert(`${actionData.title}\n\n${actionData.html || ''}`);
};

export default dialog;
